module.exports = __webpack_public_path__ + "static/feats-milestones-2db5dccf2d8139ed080536e95a38d091.png";